module.exports = __webpack_public_path__ + "static/img/iconLogo.7fa7836d.png";